export default __webpack_public_path__ + "static/Year1820-1ab1820dfa5fd644522291a1ad690ddb.jpg";